import * as React from 'react';

const UNSUPPORTED_METHODS = ['PUT', 'DELETE', 'PATCH'];

class CSRFForm extends React.Component {
  csrfToken() {
    const csrfMetaTag = document.querySelector('meta[name=csrf-token]');

    if (csrfMetaTag) {
      return csrfMetaTag.content;
    }

    return '';
  }

  unsupportedMethod() {
    return UNSUPPORTED_METHODS.indexOf(this.props.method.toUpperCase()) > -1;
  }

  methodInput() {
    if (this.unsupportedMethod()) {
      return <input type="hidden" name="_method" value={this.props.method} />;
    }
  }

  method() {
    if (this.unsupportedMethod()) {
      return 'POST';
    }
    return this.props.method;
  }

  render() {
    return (
      <form {...this.props} method={this.method()}>
        <input type="hidden" name="authenticity_token" value={this.csrfToken()} />
        {this.methodInput()}
        {this.props.children}
      </form>
    );
  }
}

export default CSRFForm;



// WEBPACK FOOTER //
// ./src/components/shared/csrf_form.jsx